/**
 * @generated SignedSource<<8c0ca27bc67e09dbd08fcf6cc62346e6>>
 * @relayHash caf8b569c6fb4ce4b97ea40957999984
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4627bfda598e74a639d6592afd61880a7b37665c8a45879511ebd9bc94c05b61

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AtlaskitAtlassianNavigationNav4Query$variables = {
  includeExtraMenuItems: boolean;
};
export type AtlaskitAtlassianNavigationNav4Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Nav4NotificationsData" | "Nav4Profile">;
};
export type AtlaskitAtlassianNavigationNav4Query = {
  response: AtlaskitAtlassianNavigationNav4Query$data;
  variables: AtlaskitAtlassianNavigationNav4Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeExtraMenuItems"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AtlaskitAtlassianNavigationNav4Query",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "Nav4Profile"
      },
      {
        "kind": "FragmentSpread",
        "name": "Nav4NotificationsData"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AtlaskitAtlassianNavigationNav4Query",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "condition": "includeExtraMenuItems",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "email"
                      }
                    ],
                    "type": "AtlassianAccountUser"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "unseenNotificationCount"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4627bfda598e74a639d6592afd61880a7b37665c8a45879511ebd9bc94c05b61",
    "metadata": {},
    "name": "AtlaskitAtlassianNavigationNav4Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1cb9afae9d2acba5cbce53e5e82713c8";

export default node;
